import PropTypes from 'prop-types';
import React from 'react';

import { Container, SearchInput, SearchIcon } from './SearchField.styled';

const KEY_MAP = {
  Enter: 'Enter',
};

export default function SearchField({
  placeholder,
  searchValue,
  onChange,
  onSearch,
  ...props
}) {
  const handleKeyPress = (event) => {
    const { key } = event;
    if (KEY_MAP[key]) onSearch(event);
  };

  return (
    <Container>
      <SearchInput
        placeholder={placeholder}
        value={searchValue}
        onChange={onChange}
        onKeyPress={handleKeyPress}
        type="search"
        name="search"
        {...props}
      />
      <SearchIcon onClick={onSearch} />
    </Container>
  );
}

SearchField.propTypes = {
  placeholder: PropTypes.string,
  searchValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};

SearchField.defaultProps = {
  placeholder: '',
};
